function updateTransparentHeaderOffset() {
    const header = document.querySelector('#header-component');
    const headerGroup = document.querySelector('#header-group');
    const hasHeaderSection = headerGroup?.querySelector('.header-section');
    
    if (!hasHeaderSection || !header?.hasAttribute('transparent')) {
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
      return;
    }
  
    const hasImmediateSection = hasHeaderSection.nextElementSibling?.classList.contains('shopify-section');
    const shouldApplyOffset = !hasImmediateSection ? '1' : '0';
    document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
}
class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
      
        // Get announcement bar height
        this.getAnnouncementBarHeight();
      
        this.setHeaderHeight();
      
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
      
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
      
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
      
        this.createObserver();
      
        // ✅ Ensure headerBounds is ready before calling onScroll
        this.headerBounds = this.header.getBoundingClientRect();
        this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    getAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      this.announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Use announcement bar height if it exists, otherwise use header bounds
      const scrollThreshold = this.announcementBarHeight > 0 ? this.announcementBarHeight : this.headerBounds.bottom;
      const resetThreshold = this.announcementBarHeight > 0 ? this.announcementBarHeight : this.headerBounds.top;

      if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > scrollThreshold) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= resetThreshold) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      const headerWrapper = document.querySelector('.head-transparent .header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.add('no-transition');
      }
      
      if (this.headerIsAlwaysSticky) return;
      
      // Remove transition when becoming sticky (instant change)
     
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      const headerWrapper = document.querySelector('.head-transparent .header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.remove('no-transition');
      }
      if (this.headerIsAlwaysSticky) return;
      // Restore smooth background transition when returning to normal position
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
}

customElements.define('sticky-header', StickyHeader);